export default "https://cdn-static.gokick.com/assets/4e1d6b599b0c658e33aa5c1b8604da35a9a49f05/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";